import { schema } from 'normalizr';
import { productSchema } from './products';
import { filterSchema } from './filters';

/**
 * Common schemas can be placed here to avoid circular dependencies in the
 * action files.
 */

export const agreementSchema = new schema.Entity(
  'agreements',
  {
    products: [productSchema],
    filters: [filterSchema],
  },
  { idAttribute: 'address' },
);

export const contractSchema = new schema.Entity(
  'contracts',
  {
    agreements: [agreementSchema],
  },
  { idAttribute: 'address' },
);
